// extracted by mini-css-extract-plugin
module.exports = {"owl_dots":"PaginationDots_owl_dots__cpCqf","owl_dot":"PaginationDots_owl_dot__09Op7","selected":"PaginationDots_selected__cBXPC","deselected":"PaginationDots_deselected__7nMWt"};